<template>
	<div class="update">
		<h2 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">数据录入<img v-if="!showList" class="back-list" @click="checkList" src="../../../assets/images/main_bio_back.png" alt="返回"></h2>
		
		<div class="search" @keyup.enter="getList">
			<el-input
				v-model="mobile"
				class="qjc-fts-14"
				placeholder="请输入手机号"
				onkeyup="value=value.replace(/[^\d]/g,'')"
				:disabled="!showList"
			></el-input>
			<el-button @click="getList" :disabled="!showList" :loading="submiting" class="qjc-fts-16">查询</el-button>
		</div>
		
		<div v-if="showList">
			<el-table
				:data="list"
				class="list qjc-fts-14"
				header-cell-class-name="list-header qjc-ftw-500 qjc-c-dark"
			>
				<el-table-column
					prop="package"
					label="套餐内容"
					class-name="basic"
				>
					<template slot-scope="scope">
						{{ scope.row.package == 1?'健康100':(scope.row.package == 2?'自由定制':'未知') }}
					</template>
				</el-table-column>
				
				<el-table-column
					prop="sex"
					label="性别"
					class-name="sex"
				>
					<template slot-scope="scope">
						{{ scope.row.sex == '1'?'男':(scope.row.sex == '2'?'女':'未知') }}
					</template>
				</el-table-column>
				
				<el-table-column
					prop="created_at"
					label="体检日期"
					class-name="examDate"
				></el-table-column>
				
				<el-table-column
					prop="operator"
					label="操作"
					class-name="operator"
				>
					<template slot-scope="scope">
						<div @click="toUpdate(scope.row)" class="update-btn qjc-c-primary">{{ scope.row.is_finish == 1?'录入':(scope.row.is_finish == 80?'修改':'未知') }}</div>
					</template>
				</el-table-column>
				
			</el-table>
			
			<el-pagination
				class="pagination qjc-texta-c"
				layout="prev, pager, next"
				hide-on-single-page
				:current-page.sync="pageData.page"
				:page-count="pageData.pagecount"
				:page-size="pageData.pagesize"
				:total="pageData.count"
				@current-change="pageChange"
			></el-pagination>
		</div>
		<!-- 根据type判断录入还是修改 -->
		<biochemical v-if='showInsert' type="update" :checkList="checkList" :formData="formData"></biochemical>
		
		<insert-updata-template v-if='showUpdata' type="update" :checkList="checkList" :hasFb="hasFb" :formData="formData" :mobile="mobile" ></insert-updata-template>
		
	</div>
</template>

<script>
	import { mainDataQuery, mainDataSubmit } from '@/utils/axios.js'
	import biochemical from './biochemical';
	import InsertUpdataTemplate from '@/components/InsertUpdata'
	
	export default{
		name: 'mainDataUpdate',
		data() {
			return {
				showList: true,// 列表信息展示
				
				showInsert: false,// 录入信息展示
				
				showUpdata: false,// 修改信息展示
				
				mobile: '',
				
				submiting: false,// 正在请求
				
				list: [],//历史记录列表
				
				pageData: {
					count: 0,// 总条数
					page: 1,// 当前页
					pagecount: 0,// 总页数
					pagesize: 12// 每页条数
				},
				
				hasFb: false, // 是否含有骨折
				
				formData: {
					sbp: '',// 收缩压
					dbp: '',// 舒张压
					
					//问卷信息
					area: '',
					marry: '',
					childcnt: '',
					drink: '',
					smoke: '',
					habeat: '',
					vege: '',
					habsport: '',
					sleep: '',
					
					//体型信息
					height: '',
					weight: '',
					bust: '',
					waist: '',
					hip: '',
					fat: '',
					
					//生化指标
					examine: [
						{"ne": "WBC", "ve": "", "ut": "A"},
						{"ne": "HGB", "ve": "", "ut": "A"},
						{"ne": "PLT", "ve": "", "ut": "A"},
						{"ne": "FG", "ve": "", "ut": "B"},
						{"ne": "HBA1C", "ve": "", "ut": "A"},
						{"ne": "CHOL", "ve": "", "ut": "B"},
						{"ne": "LDLC", "ve": "", "ut": "B"},
						{"ne": "HDLC", "ve": "", "ut": "B"},
						{"ne": "TG", "ve": "", "ut": "B"},
						{"ne": "GOT", "ve": "", "ut": "A"},
						{"ne": "GPT", "ve": "", "ut": "A"},
						{"ne": "ALP", "ve": "", "ut": "A"},
						{"ne": "ALB", "ve": "", "ut": "B"},
						{"ne": "CRE", "ve": "", "ut": "B"},
						{"ne": "UA", "ve": "", "ut": "B"},
						{"ne": "EGFR", "ve": "", "ut": "A"}
					],
					
					//个人病史 是否服药
					disease: [
						{"KDIS": "K01", "LEVEL": "0"},
						{"KDIS": "K02", "LEVEL": "0"},
						{"KDIS": "K03", "LEVEL": "0"},
						{"KDIS": "K04", "LEVEL": "0"},
						{"KDIS": "K05", "LEVEL": "0"},
						{"KDIS": "K06", "LEVEL": "0"},
						{"KDIS": "K07", "LEVEL": "0"},
						{"KDIS": "K08", "LEVEL": "0"},
						{"KDIS": "K09", "LEVEL": "0"},
						{"KDIS": "K10", "LEVEL": "0"},
						{"KDIS": "K11", "LEVEL": "0"},
						{"KDIS": "K12", "LEVEL": "0"},
						{"KDIS": "K13", "LEVEL": "0"},
						//新增
						{"KDIS": "K14", "LEVEL": "0"},
						{"KDIS": "K15", "LEVEL": "0"},
						{"KDIS": "K16", "LEVEL": "0"},
						{"KDIS": "K17", "LEVEL": "0"},
						{"KDIS": "K18", "LEVEL": "0"},
						{"KDIS": "K19", "LEVEL": "0"}
					],
					oper:[],
					famdis:[],
					
					id: '',// id(数据修改必须)
					
					package: ''// 所属套餐(用来区分是否显示舒张压和收缩压)
					
				},// 数据存储
				examine: [
					{"ne": "WBC", "ve": "", "ut": "A"},
					{"ne": "HGB", "ve": "", "ut": "A"},
					{"ne": "PLT", "ve": "", "ut": "A"},
					{"ne": "FG", "ve": "", "ut": "B"},
					{"ne": "HBA1C", "ve": "", "ut": "A"},
					{"ne": "CHOL", "ve": "", "ut": "B"},
					{"ne": "LDLC", "ve": "", "ut": "B"},
					{"ne": "HDLC", "ve": "", "ut": "B"},
					{"ne": "TG", "ve": "", "ut": "B"},
					{"ne": "GOT", "ve": "", "ut": "A"},
					{"ne": "GPT", "ve": "", "ut": "A"},
					{"ne": "ALP", "ve": "", "ut": "A"},
					{"ne": "ALB", "ve": "", "ut": "B"},
					{"ne": "CRE", "ve": "", "ut": "B"},
					{"ne": "UA", "ve": "", "ut": "B"},
					{"ne": "EGFR", "ve": "", "ut": "A"}
				],
				
			}
		},
		components: {
			biochemical,
			InsertUpdataTemplate
		},
		methods: {
			// 录入或修改生化切换回列表
			checkList() {
				this.showList = true;
				this.showInsert = false;
				this.showUpdata = false;
				this.getList();
			},
			
			getList() {
				if(this.mobile){
					// 正在请求
					this.submiting == true;
				
					mainDataQuery({
						mobile: this.mobile,
						page: this.pageData.page,
						pagesize: this.pageData.pagesize
					}).then(res => {
						// 请求成功
						this.submiting == false;
						
						if(res.code == 200){
							this.list = res.data.data;
							// 分页
							var pager = res.data.pager;
							for(var key in pager){
								pager[key] = parseInt(pager[key]);
							}
							this.pageData = pager;
						}else{
							this.$myAlert({
								type: 'fail',
								content: res.msg
							});
						}
					})
				}else{
					this.$myAlert({
						title: '电话号码不能为空'
					});
				}
			},
			
			// 列表切换
			pageChange(page) {
				this.pageData.page = page;
				this.getList();
			},
			
			// 切换修改页
			toUpdate(data) {
				if(data.is_finish == 80){// 已完成(修改)
					mainDataSubmit({
						id: data.id,
						act: 'query'
					}).then(res => {
						if(res.code == 200){
							if(res.data.fbdisease && res.data.fbdisease.length > 0) {
								this.hasFb = true
							} else {
								this.hasFb = false
							}
							this.formData = res.data
							this.formData.examine = res.data.examine;
							this.formData.sbp = res.data.sbp;
							this.formData.dbp = res.data.dbp;
							this.showList = false;
							this.showInsert = false;
							this.showUpdata = true;
							this.formData.package = data.package;
							this.formData.id = data.id;
							this.formData.act = 'update'
						}else{
							this.$myAlert({
								title: res.msg
							});
						}
					});
				}else if(data.is_finish == 1){// 录入
					this.showList = false;
					this.showInsert = true;
					this.showUpdata = false;
					let insertData = {
						examine: this.examine,
						id: data.id,
					}
					this.formData = insertData
				}
				
			}
		}
	}
</script>

<style scoped>
	.search >>> .el-input__inner{
		height: 0.36rem;
		line-height: 0.14rem;
		font-size: 0.14rem;
		padding: 0.1rem 0.12rem;
		background-color: #FAFBFC;
	}
	
	.list >>> .el-table__body,
	.list >>> .el-table__footer, 
	.list >>> .el-table__header{
		table-layout: auto;
	}
	.list >>> .operate .cell{
		width: 0.84rem;
		padding-left: 0.16rem;
	}
	.list >>> .list-header{
		background-color: #FAFBFC;
	}
	.list >>> .list-header .cell{
		line-height: 0.16rem;
	}
	.pagination >>> button{
		width: 0.32rem;
		height: 0.32rem;
		line-height: 0.32rem;
	}
	.pagination >>> button .el-icon{
		font-size: 0.14rem;
	}
	.pagination >>> li{
		width: 0.32rem;
		height: 0.32rem;
		line-height: 0.32rem;
		font-size: 0.14rem;
		font-weight: 400;
		color: #40444D;
		border: 0.01rem solid transparent;
		border-radius: 0.08rem;
		margin: 0 0.06rem;
		padding: 0;
		overflow: visible;
	}
	.pagination >>> li:hover,
	.pagination >>> li.active{
		color: #6681FA;
		font-weight: 600;
		border-color: #6681FA;
		border-left: 0.01rem solid #6681FA;
	}
</style>
<style lang="scss" scoped>
	.update{
		.back-list{
			width: 0.16rem;
			height: 0.16rem;
			cursor: pointer;
		}
		
		.search{
			margin-top: 0.32rem;
			
			.el-input{
				width: 5.05rem;
			}
			.el-button{
				width: 0.72rem;
				height: 0.36rem;
				line-height: 0.36rem;
				font-size: 0.15rem;
				padding: 0;
				margin-left: 0.16rem;
			}
		}
		.list{
			color: #777F8F;
			margin-top: 0.4rem;
			
			.iconfont{
				font-size: 0.12rem;
				
				&.delete-icon{
					position: relative;
					color: #777F8F;
					
					&::after{
						position: absolute;
						top: 50%;
						left: 50%;
						width: 100%;
						height: 0.02rem;
						content: '';
						background-color: #FF4C52;
						border-radius: 0.01rem;
						transform: translate(-50%,-50%);
					}
				}
			}
			.update-btn{
				cursor: pointer;
			}
		}
		.pagination{
			margin-top: 0.24rem;
		}
	}
</style>